// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
export const brewcontrolWiringLineageId = (z.number());
export const brewcontrolWiringLineage = z.object({
    id: brewcontrolWiringLineageId,
    created_at: z.date(),
    updated_at: z.date(),
});
export const brewcontrolWiringLineageInitializer = z.object({
    id: brewcontrolWiringLineageId.optional(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
});
export const brewcontrolWiringLineageMutator = z.object({
    id: brewcontrolWiringLineageId.optional(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
});
//# sourceMappingURL=BrewcontrolWiringLineage.js.map